module.exports = __webpack_public_path__ + "static/my-dashboard-c451a7d685b594c31242992322fa774a.gif";